export { default } from './EventTitle';
